import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subject } from "rxjs";
import { GenericService } from "../service/API/generic.service";
import { environment } from "../../../environments/environment";
@Component({
  selector: "app-generic-info",
  templateUrl: "./generic-visitor-info.component.html",
  styleUrls: ["./generic-visitor-info.component.scss"],
})
export class GenericVisitorInfoComponent implements OnInit,OnDestroy {
  @Input() componentId;
  receivedData: any;
  isOurVoter:string;
  photoflag:boolean = true;
  entityName: string = "profileImage";
  @Input() editableInviter;
  @Input() editableReference;
  apiBaseUrl = environment.API_BASE;
  picture:any;

  private unsubscribe$: Subject<any> = new Subject<any>();
  constructor(private genericservice: GenericService) {}
  getData() {
    
    if(this.componentId == 1){
      this.receivedData = this.editableInviter
      this.picture = this.apiBaseUrl + "/file-uploader/downloadS3?path=" + (this.receivedData || {}).ProfileImage;
      // console.log(this.picture);
      
    }else if(this.componentId == 2){
      this.receivedData = this.editableReference
      this.picture = this.apiBaseUrl + "/file-uploader/downloadS3?path=" + (this.receivedData || {}).ProfileImage;
      // console.log(this.picture);
      
    }
 
    this.genericservice.messageSource.subscribe((response: any) => {

      
      if (this.componentId == response.id) {
        this.receivedData = response.data;
        
        //is Our Voter
        let isVoter = response.data.isVoter;
        if(isVoter == true){
          this.isOurVoter = "Yes";
        }else{
          this.isOurVoter = "No"
        }
        //profile img
        // let profilePhoto = response.data.ProfileImage
        // if (profilePhoto != null || profilePhoto != undefined) {
          
          // }
      }
      return;
    });
  }

  

  ngOnInit() {
    this.getData();
  }
  ngOnDestroy(){
    this.genericservice.messageSource.next({});
  }
}
